import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { productService } from '../../services/api';
import { toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
interface ProductFormProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const ProductForm: React.FC<ProductFormProps> = ({ show, onHide, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    reference: '',
    name: '',
    description: '',
    unit: 'Unité',
    purchase_price: '',
    selling_price_ht: '',
    vat_rate: '20',
    current_stock: '0',
    minimum_stock: '0',
    location: '',
    type: 'product',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = {
        ...formData,
        purchase_price: parseFloat(formData.purchase_price) || 0,
        selling_price_ht: parseFloat(formData.selling_price_ht) || 0,
        vat_rate: parseFloat(formData.vat_rate) || 20,
        current_stock: parseInt(formData.current_stock) || 0,
        minimum_stock: parseInt(formData.minimum_stock) || 0,
      };

      await productService.create(data);
      toast.success('Produit créé avec succès');
      onSuccess();
      onHide();
      setFormData({
        reference: '',
        name: '',
        description: '',
        unit: 'Unité',
        purchase_price: '',
        selling_price_ht: '',
        vat_rate: '20',
        current_stock: '0',
        minimum_stock: '0',
        location: '',
        type: 'product',
      });
    } catch (error) {
      toast.error('Erreur lors de la création du produit');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Nouveau produit</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Référence *</Form.Label>
                <Form.Control
                  type="text"
                  name="reference"
                  value={formData.reference}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nom *</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <CKEditor
              editor={ClassicEditor as any}
              data={formData.description}
              onChange={(event, editor) => {
                const data = editor.getData();
                setFormData(prev => ({ ...prev, description: data }));
              }}
            />
          </Form.Group>

          

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Type</Form.Label>
                <Form.Select
                  name="type"
                  value={formData.type}
                  onChange={handleInputChange}
                >
                  <option value="product">Produit</option>
                  <option value="service">Service</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Unité</Form.Label>
                <Form.Control
                  type="text"
                  name="unit"
                  value={formData.unit}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Emplacement</Form.Label>
                <Form.Control
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Prix d'achat</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="purchase_price"
                  value={formData.purchase_price}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Prix de vente HT *</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="selling_price_ht"
                  value={formData.selling_price_ht}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>TVA (%)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="vat_rate"
                  value={formData.vat_rate}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Stock initial</Form.Label>
                <Form.Control
                  type="number"
                  name="current_stock"
                  value={formData.current_stock}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Stock minimum</Form.Label>
                <Form.Control
                  type="number"
                  name="minimum_stock"
                  value={formData.minimum_stock}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Annuler
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? 'Création...' : 'Créer le produit'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ProductForm;